import React from 'react';
import ArrayUtil from '@leverege/array-util';
import { GlobalState } from '@leverege/ui-redux';
import { Toast } from '@leverege/ui-elements';
import { EditorDialog } from '@leverege/ui-plugin';
import { UserValidator } from '@leverege/api-validator';
import I18N from '@leverege/i18n';
import Icons from "../Icons.js";
import AddEditApiAccessKeysEditor from "./AddEditApiAccessKeysEditor.js";
const {
  t,
  tIcon
} = I18N.ns('apiAccessKeyManagement.apiAccessKey.AddEditApiAccessKeysDialog');
export default class AddEditApiAccessKeysDialog extends React.Component {
  onOkay = async event => {
    const {
      apiAccessKey,
      onClose
    } = event.data;
    if (apiAccessKey) {
      await this.onUpdateApiAccessKey(event);
    } else {
      await this.onCreateApiAccessKey(event);
    }
    onClose();
  };
  onCreateApiAccessKey = async event => {
    const {
      actions
    } = event.data;
    const {
      name,
      roles
    } = event.value;
    try {
      // Create api access key.
      const apiAccessKey = await GlobalState.dispatch(actions.apiAccessKeys().create({
        name
      }));

      // Add user roles.
      await GlobalState.dispatch(actions.user(apiAccessKey.id).addRoles(roles.map(r => r.id)));
      Toast.success(t('toastSuccess_create'));
    } catch (error) {
      Toast.error(t('toastError_create'));
    }
  };
  onUpdateApiAccessKey = async event => {
    const {
      actions,
      apiAccessKey
    } = event.data;
    const {
      name,
      roles,
      originalRoles
    } = event.value;
    try {
      // Update api access.
      await GlobalState.dispatch(actions.apiAccessKey(apiAccessKey.id).update({
        name
      }));
      const rolesDiff = ArrayUtil.diffByKey(originalRoles, roles, 'id');

      // Add user roles.
      if (rolesDiff.added.length > 0) {
        await GlobalState.dispatch(actions.user(apiAccessKey.id).addRoles(rolesDiff.added.map(r => r.id)));
      }

      // Remove user roles.
      if (rolesDiff.removed.length > 0) {
        await GlobalState.dispatch(actions.user(apiAccessKey.id).removeRoles(rolesDiff.removed.map(r => r.id)));
      }
      Toast.success(t('toastSuccess_update'));
    } catch (error) {
      Toast.error(t('toastError_update'));
    }
  };
  validator = data => {
    return UserValidator.roles(data?.roles) == null;
  };
  render() {
    const {
      show,
      onClose,
      projectId,
      apiAccessKey,
      actions,
      Selector,
      selectorProps,
      editorVariants
    } = this.props;
    return /*#__PURE__*/React.createElement(EditorDialog
    // eslint-disable-next-line max-len
    , {
      icon: tIcon(apiAccessKey ? 'editDialogIcon' : 'addDialogIcon', apiAccessKey ? Icons.apiAccessKeyEditDialogIcon : Icons.apiAccessKeyAddDialogIcon),
      title: t(apiAccessKey ? 'titleLabel_update' : 'titleLabel_create'),
      okayLabel: t('okayLabel'),
      cancelLabel: t('cancelLabel'),
      eventData: this.props,
      show: show,
      onClose: onClose,
      onOkay: this.onOkay,
      validator: this.validator,
      editor: AddEditApiAccessKeysEditor,
      editorVariants: {
        pane: 'userEditor|rootEditor|form',
        header: 'userEditorHeader|rootEditorHeader|formHeader',
        body: 'userEditorContent|rootEditorContent|formBody',
        title: 'userEditorTitle|rootEditorTitle|formTitle',
        footer: 'userEditorFooter|rootEditorFooter|formFooter',
        ...editorVariants
      },
      editorProps: {
        projectId,
        actions,
        apiAccessKey,
        roleSelector: Selector,
        selectorProps
      }
    });
  }
}